import type { ShopperSearch } from '@/scapi';
import {
    PLP_BADGE_EXCLUDED_REFINEMENT_IDS,
    PLP_SYSTEM_REFINEMENT_IDS,
} from '@/components/eataly-plp-filters/lib/types';

function isUserFacingRefinement(attributeId: string, excludedAttributeIds: ReadonlySet<string>): boolean {
    return !PLP_SYSTEM_REFINEMENT_IDS.has(attributeId) && !excludedAttributeIds.has(attributeId);
}

export function countUserSelectedRefinements(
    selected: ShopperSearch.schemas['ProductSearchResult']['selectedRefinements'] | undefined,
    excludedAttributeIds: ReadonlySet<string> = PLP_BADGE_EXCLUDED_REFINEMENT_IDS
): number {
    if (!selected) {
        return 0;
    }

    return Object.keys(selected).filter((id) => isUserFacingRefinement(id, excludedAttributeIds)).length;
}

export function countUserRefinesFromUrl(
    refines: string[],
    excludedAttributeIds: ReadonlySet<string> = PLP_BADGE_EXCLUDED_REFINEMENT_IDS
): number {
    return refines.filter((refine) => {
        const attributeId = refine.split('=')[0];
        return attributeId && isUserFacingRefinement(attributeId, excludedAttributeIds);
    }).length;
}
